export * from './single-text.dialog.component';
